import React, {useEffect, useRef, useState} from 'react';

import './HP.css';
import {useTypedSelector} from "../../../hooks/useTypedSelector";
import {useActions} from "../../../hooks/useActions";


function HP({hp, side}) {

    const {phase, playedCard, cpuPlayedCard} = useTypedSelector(state => state.game);
    const {tutorial} = useTypedSelector(state => state.auth);
    const {coords, showHpChange} = useTypedSelector(state => state.animation);
    const {playCard, setPlayedCard, setPhase, setTutorial, setCoords} = useActions();

    const elementRef = useRef(null);

    const [delayedHp, setDelayedHp] = useState(hp);

    let hpDelayTimeOut = 1;
    if (cpuPlayedCard.card !== null) {
        hpDelayTimeOut = 1000;
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setDelayedHp(hp);
        }, hpDelayTimeOut);

        return () => clearTimeout(timer);
    }, [hp]);


    useEffect(() => {
        if (elementRef.current) {
            // @ts-ignore
            const rect = elementRef.current.getBoundingClientRect();

            if(!rect){
                return;
            }
            const key = side + '_hp' ;
            const elementCoords = {
                x: Math.round(rect.left + rect.width / 2),
                y: Math.round(rect.top + rect.height / 2),
            }
            coords[key] = elementCoords;
            setCoords(coords);
        }
    }, []);

    let sideClass = 'hp_' + side;

    let targetClasses = '';
    let targetActive = false;

    if (phase === 'select_spell_target'
        && playedCard.target === null
        && side === playedCard.card?.ability.side_target
        && (playedCard.card?.ability.aim_target === 'castle' || playedCard.card?.ability.aim_target === 'unit_castle')
    ) {

        if (side == 'player') {
            targetClasses += ' hpPlayerTargetActive';
        } else {
            targetClasses += ' hpCpuTargetActive';
        }
        targetActive = true;
    }
    const setTargetAndSpellUnit = function () {

        // Tutorial
        if (tutorial.step === 'SpellTarget75') {
            tutorial.step = 'BattleFinish80';
            setTutorial(tutorial);
        }
        //

        if (side === 'cpu') {
            playedCard.target = {key: 'target_cpu_hp', value: '1', side: 'cpu'};
        } else {
            playedCard.target = {key: 'target_player_hp', value: '1', side: 'player'};
        }
        playCard(playedCard);

        setPlayedCard({card: null, handKey: null, target: null});
        setPhase('play_spell');
    }

    let hpChangeClasses = 'hpChange';
    let hpChangeAnimation = '';

    let value = '';

    if (showHpChange.side !== null && showHpChange.side === side) {
        hpChangeClasses += ' hpChangeActive';
        hpChangeAnimation = 'hpChangeAnimationPlayer';
        if(showHpChange.value!== null) {
            if (showHpChange.value > 0) {
                value = '+' + showHpChange.value;
                hpChangeAnimation += ' hpChangeAnimationHeal';
            }else{
                value = '' + showHpChange.value;
                hpChangeAnimation += ' hpChangeAnimationDamage';
            }
        }
    }

    return (
        <div className={sideClass + targetClasses} onClick={() => {
            if (targetActive) {
                setTargetAndSpellUnit();
            }
        }}>
            <div className={hpChangeClasses}><div className={hpChangeAnimation + ' font-oswald-bold'}>{value}</div></div>
            <div ref={elementRef} className={'hpAmount font-oswald-bold'}>{delayedHp}</div>
        </div>
    );
}

export default HP;